import { useEffect, useReducer, useRef } from "react";

export default function useSeriesIntroAnimation(ids) {
  const completed = useRef(new Set());
  const [, refresh] = useReducer(value => value + 1, 0);
  useEffect(() => {
    const selected = new Set(ids);
    for (const id of completed.current) {
      if (!selected.has(id)) completed.current.delete(id);
    }
  }, [ids]);

  return id => ({
    isAnimationActive: !completed.current.has(id) &&
      !window.matchMedia?.("(prefers-reduced-motion: reduce)").matches,
    animationDuration: 350,
    animationEasing: "ease-out",
    onAnimationEnd: () => {
      if (completed.current.has(id)) return;
      completed.current.add(id);
      refresh();
    },
  });
}
